














































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

@Component
export default class PatientFileContact extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  @Provide() patientHavePathology: boolean = true;

  checkPatientInfos(value: any, categ?: any) {
    return this.patient.infos[categ][value] ? this.patient.infos[categ][value] : '-';
  }
}
